export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_eroscapital.png",
      alt: "Nome da extensão",
    },
    title: "Eros Capital Trading Co.",
    text: [
      "Unimos conhecimento técnico, automação e metodologia institucional para transformar o modo como o trader se posiciona no mercado. ",
      "Aqui, não operamos achismos. Cada decisão é guiada por lógica, estatística e precisão. ",
    ],
    testimonial: {
      text: "Mais do que uma marca, somos um projeto construído sobre três pilares: \nestratégia, tecnologia e performance. ",
      author: {
        name: "Pedro Quelhas, Fundador e Head de Estratégias - Eros Capital Trading Co.",
        // picture: "https://i.pravatar.cc/150?img=70",
      },
    },
  },
  stats: {
    title: "Alguns números da Eros Capital Trading Co. ",
    subtitle: "Estratégia, tecnologia e performance. ",
    data: [
      {
        value: "+7",
        description: "anos de experiência no mercado financeiro",
      },
      {
        value: "+16",
        description: "estratégias validadas estatisticamente",
      },
      {
        value: "+10",
        description: "meses de histórico em conta real",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs da Eros Capital Trading Co.?",
    subtitle: "Veja quais as principais vantagens dos robôs da Eros Capital Trading Co.",
    data: [
      {
        title: "7 dias para testar",
        description: "Teste as nossas estratégias e confira a performance em sua conta. ",
      },
      {
        title: "100% automatizado ",
        description: "Realizamos todos os ajustes e parametrizações das estratégias automaticamente.",
      },
      {
        title: "Suporte individual ",
        description:
          "Priorizamos um atendimento individual de qualidade visando sempre esclarecer as dúvidas dos nossos clientes. ",
      },
      {
        title: "Sem emocional",
        description:
          "Muitas vezes agimos de maneira irracional e impulsiva em nossos investimentos. Com as estratégias automatizadas você não terá mais esse problema!",
      },
      {
        title: "Velocidade ",
        description:
          "Os nossos algoritmos são capazes de realizar milhares de cálculos por segundo e tomam decisões muito mais rápido do qualquer ser humano.",
      },
      {
        title: "Ganhe tempo para o que realmente importa",
        description:
          "Você não precisa ficar na frente da tela para realizar as suas operações. Escolha as suas estratégias e deixe que a plataforma opere por você.",
      },
    ],
  },
  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Ative agora mesmo a extensão da Eros Capital!",
  },
  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Eros Capital Trading Co.",
    col1: [
      "Mais do que uma marca, somos um projeto construído sobre três pilares: \nestratégia, tecnologia e performance.  \n\nIdealizada para se adaptar as constantes mudanças do mercado financeiro, com a expertise na criação de algoritmos eficazes e lucrativos: Assim nasceu a Eros Capital Trading Co. ",
      "Utilizando algoritmos próprios que se adaptam a dinâmica do mercado, nossas estratégias farão de você se separar da grande massa, transformando qualquer pessoa em um investidor de sucesso.",
    ],
    col2: [
      "Todas as nossas estratégias são monitoradas e ajustadas constantemente com base em métricas estatísticas, comportamento do mercado e análises quantitativas aprofundadas, garantindo aderência ao cenário atual e longevidade operacional. ",
    ],
  },
  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da Eros Capital Trading Co.",
  },
  strategies: {
    title: "Estratégias Smart Money Concepts (SMC)",
    heading: "Algoritmos desenvolvidos com base em modelos institucionais à sua disposição. ",
    subtitle:
      "Estratrégias prontas, desenvolvidas combinando os operacionais dos investidores institucionais com indicadores técnicos para a validação de entradas \n\n \n\nComece agora mesmo com apenas alguns cliques! ",
  },
};
